#import '../fragments/account-plan-fragment.graphql'

query GetAccountBilling {
    accountBilling {
        currentPlan {
            ...AccountPlanFragment
        }
        lastThreeInvoices {
            id
            amount
            date
        }
    }
}
